var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakeReading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.TakeReading-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "TakeReading-st0",
    d: "M12.5,2.6C5.6,2.6,0,8.2,0,15.1c0,2.7,0.9,5.3,2.4,7.4L4.1,21c-1-1.4-1.6-3-1.8-4.8h3.6V14H2.3 c0.2-2,1-3.9,2.2-5.4L7,11.2l1.6-1.6L7.8,8.8L6,7c1.5-1.2,3.3-2,5.4-2.2v3.6h2.2V4.8c2,0.2,3.9,1,5.4,2.2l-1.8,1.8l-0.8,0.8 l1.6,1.6l2.6-2.6c1.2,1.5,2,3.3,2.2,5.4h-3.6v2.2h3.6c-0.2,1.8-0.8,3.4-1.8,4.8l1.7,1.4c1.5-2.1,2.4-4.6,2.4-7.4 C25,8.2,19.4,2.6,12.5,2.6L12.5,2.6z M12.5,10.3l-1.3,7.9c-0.3,0.3-0.5,0.8-0.5,1.3c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8 c0-0.5-0.2-0.9-0.5-1.3L12.5,10.3L12.5,10.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeReading);
export default __webpack_public_path__ + "static/media/TakeReading.ff5264cfa22ec56278fe201cb3b5d602.svg";
export { ForwardRef as ReactComponent };